import store from '../store';

const notAuthRoues = [
    "/",
    "/support"
];

export default function isAuthenticated(to, from, next) {
    const token = store.getters['user/getToken'];
    // If route is home or the user is set
    if (~notAuthRoues.indexOf(to.fullPath) || !!token) {
        // Allow
        next();
    } else {
        // return home
        next("/");
    }
}


// WEBPACK FOOTER //
// ./src/router/isAuthenticated.js